var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkUnderline',{staticClass:"page-back",attrs:{"to":_vm.to,"border-hover":true}},[_c('SvgIcon',{attrs:{"name":"arrow left"}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }